import { useFormContext, useWatch } from '@portals-platform/ui-forms';
import { useCountryOptions } from '../../../data-access/index.js';
import type { FormValues } from '../types.js';

export function useSelectedCountryName(): string {
  const { control } = useFormContext<FormValues>();
  const countryCode = useWatch({ control, name: 'countryCode' });
  const countryOptions = useCountryOptions();

  return countryOptions.find((option) => option.value === countryCode)?.label ?? '';
}
